import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import CharPlanner from './components/CharPlanner';
import translations from '../locale/pl.json';

// Initialize translations
if (!window.charPlannerData) {
    window.charPlannerData = {};
}
window.charPlannerData.i18n = translations;

ReactDOM.render(
    <React.StrictMode>
        <CharPlanner />
    </React.StrictMode>,
    document.getElementById('char-planner-root')
); 